import React from '../../vendor/react';
import { useEffect } from '../../vendor/react';
import { navigate, useLocation } from '../../vendor/react-router-dom';
import type { ReactNode } from '../../vendor/react';
import type { CommercialFeatureId } from '../../config/commercialPlans';
import { useSaas } from '../../features/saas/useSaas';

export function SubscriptionGate({ children }: { children?: ReactNode }) {
  const saas = useSaas();
  const location = useLocation();
  const allowed = ['/app/plan', '/app/cuenta', '/app/sincronizacion'];
  useEffect(() => {
    if (!saas.organizationId || !saas.blocked || allowed.some((path) => location.pathname.startsWith(path))) return;
    navigate('/app/plan', { replace: true });
  }, [saas.organizationId, saas.blocked, location.pathname]);
  return <>{children}</>;
}

export function FeatureGate({ feature, children }: { feature: CommercialFeatureId; children?: ReactNode }) {
  const saas = useSaas();
  useEffect(() => {
    if (saas.organizationId && !saas.hasFeature(feature)) navigate('/app/plan', { replace: true });
  }, [saas.organizationId, feature, saas.plan?.id]);
  if (!saas.organizationId || !saas.hasFeature(feature)) return <div className="auth-loading"><span className="loading-spinner"/><p>Verificando las funciones del plan…</p></div>;
  return <>{children}</>;
}
